module.exports = __webpack_public_path__ + "img/cssreference.399cc00f.gif";